import { render, staticRenderFns } from "./LegendToilet.vue?vue&type=template&id=6075d3bd"
import script from "./LegendToilet.vue?vue&type=script&lang=js"
export * from "./LegendToilet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports